module.exports = __webpack_public_path__ + "img/F2F9_new.a24f2a39.jpg";